<div class="kiene-content-page" *kienePermission="[1071, 1076, 1082, 1083]">
    <div class="kiene-table-header">
        <div>
            <button style="display: inline-block" (click)="goBack()" mat-icon-button matTooltip="zurück">
                <mat-icon color="primary">arrow_back</mat-icon>
            </button>
            <h2 style="display: inline-block; margin-left: 20px">Lieferant {{ supplier.bezeichnung }}</h2>
        </div>
    </div>
    <div>
        <div class="kiene-table-header">
            <mat-card style="width: 100%">
                <div style="padding-bottom: 30px">
                    <mat-tab-group [selectedIndex]="selectedTab">
                        <mat-tab label="Allgemein" *kienePermission="[1071, 1076, 1082]">
                            <h4>Allgemein</h4>
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Name des Lieferanten"
                                    matInput
                                    [(ngModel)]="supplier.bezeichnung"
                                />
                            </mat-form-field>
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Interne Lieferantennummer"
                                    matInput
                                    [(ngModel)]="supplier.lieferant_nr_intern"
                                />
                            </mat-form-field>
                            <br />
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Bezeichnung 1"
                                    matInput
                                    [(ngModel)]="supplier.bezeichnung_1"
                                />
                            </mat-form-field>
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Bezeichnung 2"
                                    matInput
                                    [(ngModel)]="supplier.bezeichnung_2"
                                />
                            </mat-form-field>
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Bezeichnung 3"
                                    matInput
                                    [(ngModel)]="supplier.bezeichnung_3"
                                />
                            </mat-form-field>
                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input
                                    type="text"
                                    placeholder="Bezeichnung Kurz"
                                    matInput
                                    [(ngModel)]="supplier.bezeichnung_kurz"
                                />
                            </mat-form-field>
                            <br />
                            <mat-checkbox [formControl]="nebenkostenCtrl">Nebenkostenlieferant</mat-checkbox>

                            <h4>Anschrift</h4>
                            <mat-form-field style="width: 81%; margin-right: 1%">
                                <input type="text" placeholder="Straße" matInput [(ngModel)]="supplier.strasse" />
                            </mat-form-field>

                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input type="text" placeholder="PLZ" matInput [(ngModel)]="supplier.plz" />
                            </mat-form-field>

                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <input type="text" placeholder="Ort" matInput [(ngModel)]="supplier.ort" />
                            </mat-form-field>

                            <mat-form-field style="width: 27%; margin-right: 1%">
                                <input type="email" placeholder="E-Mail Adresse" matInput [formControl]="emailCtrl" />
                                <span matPrefix> <mat-icon>email</mat-icon>&nbsp;&nbsp; </span>
                                <button
                                    mat-button
                                    *ngIf="emailCtrl.value"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="clearEmail()"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="emailCtrl.invalid">E-Mail Adresse ungültig</mat-error>
                            </mat-form-field>

                            <mat-form-field style="width: 27%; margin-right: 1%">
                                <span matPrefix> <mat-icon>local_phone</mat-icon>&nbsp;&nbsp; </span>
                                <input type="text" placeholder="Telefon" matInput [(ngModel)]="supplier.telefon" />
                            </mat-form-field>

                            <mat-form-field style="width: 25%; margin-right: 1%">
                                <span matPrefix> <mat-icon>phone_iphone</mat-icon>&nbsp;&nbsp; </span>
                                <input type="text" placeholder="Mobil" matInput [(ngModel)]="supplier.mobil" />
                            </mat-form-field>

                            <mat-form-field style="width: 40%; margin-right: 1%">
                                <span matPrefix> <mat-icon>print</mat-icon>&nbsp;&nbsp; </span>
                                <input type="text" placeholder="Fax" matInput [(ngModel)]="supplier.fax" />
                            </mat-form-field>

                            <mat-checkbox style="padding-top: 10px" [formControl]="faxBevorzugenCtrl"
                                >Fax gegen&uuml;ber E-Mail bevorzugen?
                            </mat-checkbox>

                            <br />
                            <p *ngIf="zeigtKreditorNurLesen()" class="kreditor-hinweis">
                                Kreditorennummer: {{ supplier?.buchungskonto || 'noch nicht vergeben' }}.
                                Die Nummer ist das Buchungskonto und wird in der FiBu eingetragen, sie entsteht nicht
                                automatisch beim Anlegen.
                            </p>
                            <ng-container *ngIf="isCreationForm">
                                <div *kienePermission="[1072, 1082]">
                                    <button
                                        style="margin-top: 40px"
                                        mat-flat-button
                                        color="accent"
                                        (click)="updateAllgemein()"
                                        >Anlegen
                                    </button>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!isCreationForm">
                                <div *kienePermission="[1073, 1082]">
                                    <button
                                        style="margin-top: 40px"
                                        mat-flat-button
                                        color="accent"
                                        (click)="updateAllgemein()"
                                        >Speichern
                                    </button>
                                </div>
                            </ng-container>
                        </mat-tab>

                        <mat-tab label="Zahlungsbedingungen" [disabled]="isCreationForm" *kienePermission="[1071, 1076]">
                            <h4>Zahlungsbedingungen</h4>
                            <mat-form-field>
                                <mat-label>Skonto (%)</mat-label>
                                <input matInput type="number" [(ngModel)]="supplier.skonto" />
                            </mat-form-field>
                            <br />
                            <!--<mat-form-field>
                                <mat-label>Rabatt in %</mat-label>
                                <input matInput type="number" [(ngModel)]="supplier.rabatt">
                              </mat-form-field><br>-->
                            <mat-form-field>
                                <mat-label>Zahlungsziel (Tage)</mat-label>
                                <input matInput type="number" [(ngModel)]="supplier.zahlungsziel" />
                            </mat-form-field>
                            <br />

                            <mat-radio-group [(ngModel)]="supplier.zahlungsart" aria-label="Zahlungsart auswählen">
                                <mat-label>Zahlungsart:</mat-label>
                                <mat-radio-button [value]="1">Lastschrift</mat-radio-button>
                                <mat-radio-button [value]="2">&Uuml;berweisung</mat-radio-button>
                            </mat-radio-group>
                            <br />
                            <mat-form-field style="margin-top: 24px">
                                <mat-label>Frachtfreigrenze</mat-label>
                                <input matInput type="number" [(ngModel)]="supplier.frachtfreigrenze" />
                            </mat-form-field>
                            <br />
                            <mat-form-field>
                                <mat-label>Frachtkosten</mat-label>
                                <input matInput type="number" [(ngModel)]="supplier.frachtkosten" />
                            </mat-form-field>
                            <div *kienePermission="[1073]" style="margin-top: 24px">
                                <button mat-flat-button color="accent" (click)="updateZahlung()">Speichern</button>
                            </div>
                        </mat-tab>

                        <mat-tab label="FiBu" [disabled]="isCreationForm" *kienePermission="[1071, 1076]">
                            <h4 style="margin-top: 24px">FiBu-Konten</h4>
                            <mat-form-field style="margin-right: 12px; min-width: 300px">
                                <mat-label>Buchungskonto (Kreditor)</mat-label>
                                <input matInput [(ngModel)]="supplier.buchungskonto" />
                            </mat-form-field>
                            <br />
                            <mat-form-field style="min-width: 300px">
                                <mat-label>Gegenkonto</mat-label>
                                <input matInput [(ngModel)]="supplier.buchungsgegenkonto" />
                            </mat-form-field>
                            <br />
                            <div *kienePermission="[1073]" style="margin-top: 24px">
                                <button mat-flat-button color="accent" (click)="updateFibu()">Speichern</button>
                            </div>
                        </mat-tab>

                        <mat-tab
                            label="Ansprechpartner"
                            [disabled]="isCreationForm"
                            *kienePermission="[1071, 1076, 1082, 1083]"
                        >
                            <h4 style="margin-top: 24px">Ansprechpartner</h4>
                            <p style="max-width: 640px">
                                Personen beim Lieferanten, zum Beispiel für Bestellungen.
                            </p>
                            <div style="display: flex; gap: 12px; flex-wrap: wrap; align-items: center">
                                <mat-form-field style="min-width: 220px">
                                    <mat-label>Name</mat-label>
                                    <input matInput [(ngModel)]="ansprechpartnerName" />
                                </mat-form-field>
                                <mat-form-field style="min-width: 180px">
                                    <mat-label>Telefon</mat-label>
                                    <input matInput [(ngModel)]="ansprechpartnerTelefon" />
                                </mat-form-field>
                                <mat-form-field style="min-width: 220px">
                                    <mat-label>E-Mail</mat-label>
                                    <input matInput [(ngModel)]="ansprechpartnerEmail" />
                                </mat-form-field>
                                <button
                                    *kienePermission="[1072, 1082]"
                                    mat-flat-button
                                    color="accent"
                                    type="button"
                                    (click)="saveAnsprechpartner()"
                                >
                                    {{ ansprechpartnerEditId ? 'Übernehmen' : 'Hinzufügen' }}
                                </button>
                                <button
                                    *ngIf="ansprechpartnerEditId"
                                    mat-button
                                    type="button"
                                    (click)="resetAnsprechpartner()"
                                >
                                    Abbrechen
                                </button>
                            </div>
                            <div *ngIf="ansprechpartner?.length" style="margin-top: 16px">
                                <div
                                    *ngFor="let person of ansprechpartner"
                                    style="display: flex; align-items: center; gap: 12px; margin-bottom: 8px"
                                >
                                    <div style="min-width: 280px">
                                        <strong>{{ person.name }}</strong>
                                        <div style="font-size: 13px; opacity: 0.8">
                                            <span *ngIf="person.telefon">{{ person.telefon }}</span>
                                            <span *ngIf="person.telefon && person.email"> · </span>
                                            <span *ngIf="person.email">{{ person.email }}</span>
                                        </div>
                                    </div>
                                    <button
                                        *kienePermission="[1072, 1082]"
                                        mat-icon-button
                                        type="button"
                                        matTooltip="Bearbeiten"
                                        (click)="editAnsprechpartner(person)"
                                    >
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                    <button
                                        *kienePermission="[1072, 1082]"
                                        mat-icon-button
                                        type="button"
                                        matTooltip="Löschen"
                                        (click)="removeAnsprechpartner(person)"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <p *ngIf="!ansprechpartner?.length" style="opacity: 0.7; margin-top: 16px">
                                Noch kein Ansprechpartner hinterlegt.
                            </p>
                        </mat-tab>

                        <mat-tab
                            label="UA-Formulare"
                            [disabled]="isCreationForm"
                            *kienePermission="[1071, 1072, 1082, 1083]"
                        >
                            <h4 style="margin-top: 24px">Untersuchungsformulare (Fremdlabor)</h4>
                            <p style="max-width: 640px">
                                Formulare mit freiem Namen hinterlegen. Optional Feld-Mapping für automatische
                                PDF-Befüllung.
                            </p>
                            <div style="display: flex; gap: 12px; align-items: center; flex-wrap: wrap">
                                <button
                                    *kienePermission="[1072, 1082]"
                                    mat-stroked-button
                                    color="accent"
                                    type="button"
                                    (click)="uploadUaFormular()"
                                >
                                    <mat-icon>upload_file</mat-icon>
                                    Formular hochladen
                                </button>
                            </div>
                            <div *ngIf="uaFormulare?.length" style="margin-top: 16px">
                                <div
                                    *ngFor="let doc of uaFormulare"
                                    style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px"
                                >
                                    <button mat-button type="button" (click)="showUaFormular(doc)">
                                        <mat-icon>picture_as_pdf</mat-icon>
                                        {{ formularLabel(doc) }}
                                    </button>
                                    <button
                                        *kienePermission="[1072, 1082]"
                                        mat-icon-button
                                        type="button"
                                        matTooltip="Felder mappen (Auto-Fill)"
                                        (click)="mapUaFormular(doc)"
                                    >
                                        <mat-icon>tune</mat-icon>
                                    </button>
                                    <button
                                        *kienePermission="[1072, 1082]"
                                        mat-icon-button
                                        type="button"
                                        matTooltip="Löschen"
                                        (click)="removeUaFormular(doc)"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <p *ngIf="!uaFormulare?.length" style="opacity: 0.7; margin-top: 16px">
                                Noch keine Formulare hinterlegt.
                            </p>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </mat-card>
        </div>
    </div>
</div>
